import SpinnerBasic from "./loaders/SpinnerBasic/SpinnerBasic";

export default function Loading() {
  return <SpinnerBasic />;
}
